import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'pr-sub-panel',
    templateUrl: './pr-sub-panel.component.html',
    styleUrls: ['./pr-sub-panel.component.scss'],
    standalone: false
})
export class PrSubPanelComponent implements OnInit {
  @Input() title: string;
  @Input() class: string;
  @Input() clazz: string;

  constructor() {}

  ngOnInit() {}
}
